import React, { useState } from 'react';
import logo from '../assets/images/LOGO.png';
import './Login.css';
import { db, auth } from '../firebase'; 
import { signInWithEmailAndPassword } from 'firebase/auth'; 
import { collection, addDoc, serverTimestamp } from "firebase/firestore"; 

const Login = ({ onLoginSuccess, destination }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState(''); 
  const [lastName, setLastName] = useState('');
  const [ndaAccepted, setNdaAccepted] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const ndaText = "I acknowledge that all information, concepts, images, business models, and operational data regarding the 'Soul Rock Museum Restaurant' project contained in this section are strictly confidential and represent the exclusive intellectual property of the creators. I formally commit to maintaining the utmost confidentiality and not to disclose, reproduce, copy, or use such materials in any way for personal, competitive, or third-party purposes, without prior written authorization.";

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    if (!ndaAccepted) {
      setError('You must accept the Non-Disclosure Agreement (NDA) to proceed.');
      return;
    }

    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);

      if (email.toLowerCase() !== "paolocimino21@gmail.com") {
        try {
          await addDoc(collection(db, "nda_logs"), {
            first_name: firstName,
            last_name: lastName,
            user_email: email.toLowerCase(),
            nda_status: "ACCEPTED",
            nda_text_agreed: ndaText,
            project_version: "Soul Rock Museum Restaurant V1",
            timestamp: serverTimestamp(),
            user_agent: navigator.userAgent
          });
        } catch (logError) {
          console.error("Warning: Could not save NDA log, but user is authenticated.", logError);
        }
      }

      onLoginSuccess(); 

    } catch (authError) {
      console.error("Auth error:", authError);
      setError('Invalid email or password.');
    }
    
    setLoading(false);
  };

  const labelStyle = { display: 'block', marginBottom: '0.5rem', fontWeight: 'bold', fontSize: '0.9rem' };
  
  // ✅ Unico stile scuro per tutti gli input
  const inputStyle = { width: '100%', boxSizing: 'border-box', padding: '1rem', borderRadius: '5px', border: '1px solid #47505b', background: '#191d24', color: '#fafafa', fontSize: '1rem' };

  return (
    <main className="sr-access">
      <header className="sr-access-brand">
        <img src={logo} alt="Soul Rock Cafe" />
        <h1>Restricted Access</h1>
        {destination && <p className="sr-access-destination" aria-live="polite">{destination}</p>}
        <p>This area contains strictly confidential material.<br />Please enter your credentials to view the project.</p>
      </header>

      <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1.5rem' }}>
        
        {/* ✅ CONTENITORE NOME E COGNOME ALLINEATI E SCURI */}
        <div style={{ width: '100%', maxWidth: '400px', display: 'flex', gap: '15px' }}>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>First Name</label>
            <input
              type="text"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
              style={inputStyle}
            />
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Last Name</label>
            <input
              type="text"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
              style={inputStyle}
            />
          </div>
        </div>

        {/* CAMPO EMAIL */}
        <div style={{ width: '100%', maxWidth: '400px', textAlign: 'left' }}>
          <label style={labelStyle}>Email Address</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={inputStyle}
          />
        </div>

        {/* CAMPO PASSWORD CON OCCHIOLINO */}
        <div className="password-group" style={{ width: '100%', maxWidth: '400px', textAlign: 'left', position: 'relative' }}>
          <label style={labelStyle}>Password</label>
          <input
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{ ...inputStyle, paddingRight: '3.5rem' }}
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="password-toggle"
            style={{
              position: 'absolute',
              right: '15px',
              top: '38px',
              background: 'none',
              border: 'none',
              color: '#ffbf80',
              cursor: 'pointer',
              fontSize: '0.75rem',
              fontWeight: 'bold',
              textTransform: 'uppercase',
              letterSpacing: '1px',
              padding: '5px',
              opacity: 1,
              transition: 'opacity 0.2s'
            }}
          >
            {showPassword ? 'HIDE' : 'SHOW'}
          </button>
        </div>

        <div style={{ background: '#12151a', padding: '1.5rem', borderRadius: '8px', border: '1px solid #383f49', width: '100%', maxWidth: '500px', marginTop: '1rem' }}>
          <h3 style={{ marginTop: 0, color: '#f07c00', fontSize: '1.2rem', textAlign: 'center', textTransform: 'uppercase' }}>Non-Disclosure Agreement (NDA)</h3>
          
          <p style={{ fontSize: '0.85rem', lineHeight: '1.6', color: '#c1c6d0', textAlign: 'justify', marginBottom: '1.5rem' }}>
            {ndaText}
          </p>
          
          <label style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={ndaAccepted}
              onChange={(e) => setNdaAccepted(e.target.checked)}
              style={{ marginTop: '3px', transform: 'scale(1.2)', cursor: 'pointer' }}
            />
            <span style={{ fontSize: '0.95rem', fontWeight: 'bold', color: '#fafafa', lineHeight: '1.4', textAlign: 'left' }}>
              By proceeding and accessing the restricted area, I accept the terms of the Non-Disclosure Agreement (NDA).
            </span>
          </label>
        </div>

        {error && (
          <div style={{ color: '#ff4d4d', fontWeight: 'bold', textAlign: 'center', background: 'rgba(255, 77, 77, 0.1)', padding: '1rem', borderRadius: '5px', width: '100%', maxWidth: '400px', fontSize: '0.9rem' }}>
            {error}
          </div>
        )}

        <button 
          type="submit" 
          disabled={loading}
          style={{ 
            background: loading ? '#555' : '#f07c00',
            color: '#000', 
            border: 'none', 
            padding: '1rem', 
            fontWeight: 'bold', 
            borderRadius: '6px', 
            fontSize: '1.1rem', 
            cursor: loading ? 'not-allowed' : 'pointer',
            marginTop: '0.5rem',
            width: '100%',
            maxWidth: '400px',
            textTransform: 'uppercase',
            letterSpacing: '1px',
            transition: 'background 0.2s'
          }}
          onMouseOver={(e) => !loading && (e.target.style.background = '#ff9a34')}
          onMouseOut={(e) => !loading && (e.target.style.background = '#f07c00')}
        >
          {loading ? 'Verifying...' : 'Access Project'}
        </button>
      </form>
      
      <style>{`
        .password-toggle:hover {
          opacity: 1 !important;
          color: #f07c00 !important;
        }
      `}</style>
    </main>
  );
};

export default Login;